import { useEffect, useMemo } from 'react';
import { CssBaseline, PaletteType } from '@material-ui/core';
import {
  createTheme,
  MuiThemeProvider,
  StylesProvider,
} from '@material-ui/core/styles';
import { ThemeProvider } from 'styled-components';
import theme from '../../theme';
import variables from '../../theme/variables';

interface AppThemeProps {
  prefersDarkMode: boolean | null;
  children: React.ReactNode;
  themeOveride?: PaletteType;
  handleGetThemeMode: () => void;
}

function AppTheme({
  prefersDarkMode = null,
  children,
  themeOveride = 'dark',
  handleGetThemeMode = () => {},
}: AppThemeProps) {
  useEffect(() => {
    handleGetThemeMode();
  }, [handleGetThemeMode]);

  const themeMode = themeOveride || (prefersDarkMode ? 'dark' : 'light');

  const muiTheme = useMemo(
    () =>
      createTheme({
        palette: {
          ...theme.palette,
          type: themeMode,
          background: {
            paper: variables.colors.backgroundDark,
            default: variables.colors.backgroundDark,
          },
        },
        // TODO: Remove @ts-expect-error when theme/overrides is converted to TS
        // Theme override files are JS — TS widens string literals (e.g. 'uppercase' → string)
        // which conflicts with MUI's strict CSS property types
        // @ts-expect-error — pre-existing type mismatch from JS theme files
        overrides: {
          ...theme.overrides,
        },
        typography: {
          ...theme.typography,
        },
        shape: {
          ...theme.shape,
        },
      }),
    [themeMode],
  );

  return (
    <StylesProvider injectFirst>
      <ThemeProvider theme={muiTheme}>
        <MuiThemeProvider theme={muiTheme}>
          <CssBaseline />
          {children}
        </MuiThemeProvider>
      </ThemeProvider>
    </StylesProvider>
  );
}

export default AppTheme;
